import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { useDispatch, useSelector } from "react-redux";

import CategoryForm from "../Category/CategoryForm";
import { Loader } from "../Utils/Loader";
import CommonModal from "../Utils/CommonModal";
import { hasPermission } from "../Utils/UtilityFunctions";

import { getAllCategory } from "../../slices/Category/GetCategory/thunk";
import { deleteCategory } from "../../slices/Category/DeleteCategory/thunk";
import { deleteSubCategory } from "../../slices/Category/DeleteSubCategory/thunk";

function CategoryCard() {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteCategoryData, setDeleteCategoryData] = useState(null);
  const [messageForPopUp, setMessageForPopUp] = useState("");
  const [currentCategories, setCurrentCategories] = useState([]);
  const [navigationStack, setNavigationStack] = useState([]);
  const dispatch = useDispatch();
  const category = useSelector((state) => state.Category.categories);
  const toggleModal = () => setShowModal(!showModal);

  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap,
  );
  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)]),
  );
  const categoryPermission = hasPermission(
    permissionsMap,
    "configuration",
    "category",
  );

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
    document.body.style.overflow = "auto";
  };

  const fetchCategories = async () => {
    await dispatch(getAllCategory(setLoading));
  };

  useEffect(() => {
    fetchCategories();
  }, [dispatch]);

  useEffect(() => {
    if (category?.length > 0) {
      const updatedCategory = category.map((item) => ({
        ...item,
        isSubCategory: false,
      }));

      setCurrentCategories(updatedCategory);
    }
  }, [category]);

  // SUCCESS
  const handleSuccess = async () => {
    await fetchCategories();
    setShowModal(false);
    setSelectedCategory(null);
    setNavigationStack([]);
  };

  // ADD CATEGORY
  const handleAddClick = () => {
    setSelectedCategory(null);
    setShowModal(true);
  };

  // EDIT CATEGORY
  const handleCardClick = (cat) => {
    setSelectedCategory(cat);
    setShowModal(true);
  };

  // DELETE CATEGORY
  const handleDelete = (e, cat) => {
    e.stopPropagation();
    setDeleteCategoryData(cat);
    setMessageForPopUp(
      `Are you sure you want to delete ${
        cat?.isSubCategory ? "sub category" : "category"
      } "${cat?.name}" ?`,
    );
    toggleDeleteModal();
  };

  const handleCategoryOpen = (cat) => {
    const subcategories = Object.entries(cat?.subcategory || {}).map(
      ([key, sub]) => ({
        ...sub,
        keyName: key,
        isSubCategory: true,
        rootCategoryId: cat?.rootCategoryId || cat?.categoryid,
        rootCategoryName: cat?.rootCategoryName || cat?.name,
        subCategoryId: sub?.categoryid,
        parentCategoryName: cat?.name,
        pathArray: [...(cat?.pathArray || []), key],
      }),
    );

    // if (subcategories.length > 0) {
    setNavigationStack((prev) => [...prev, cat]);
    setCurrentCategories(subcategories);
    // }
  };

  // BACK BUTTON
  const handleBack = () => {
    const updatedStack = [...navigationStack];
    updatedStack.pop();
    setNavigationStack(updatedStack);

    if (updatedStack.length === 0) {
      setCurrentCategories(category);
    } else {
      const lastCategory = updatedStack[updatedStack.length - 1];
      setCurrentCategories(
        Object.values(lastCategory?.subcategory || {}).map((sub) => ({
          ...sub,
          isSubCategory: true,
        })),
      );
    }
  };

  // RENDER CARDS
  const renderCategoryCards = (categories) => {
    return (
      <Row>
        {categories?.map((cat) => {
          const subCategoryLength = Object.values(
            cat?.subcategory || {},
          ).length;

          const itemLength = cat?.itemcount || 0;

          return (
            <Col
              key={cat?.categoryid}
              xs="12"
              sm="6"
              md="6"
              lg="4"
              className="mb-3"
            >
              <Card
                onClick={() => handleCategoryOpen(cat)}
                className="shadow-none w-100"
                style={{
                  border: "1px solid #DFDFDF",
                  borderRadius: "8px",
                  cursor: "pointer",
                  minHeight: "120px",
                }}
              >
                <div>
                  <CardBody className="p-4 d-flex flex-column h-100">
                    <div className="d-flex justify-content-between align-items-start">
                      {/* LEFT */}
                      <div className="d-flex">
                        <div
                          className="d-flex align-items-center justify-content-center rounded-3 text-uppercase fw-medium"
                          style={{
                            width: "52px",
                            height: "52px",
                            backgroundColor: "#FD754520",
                            minWidth: "52px",
                            color: "#FD7545",
                            fontSize: "20px",
                          }}
                        >
                          {cat?.name?.charAt(0)}
                        </div>

                        {/* CONTENT */}
                        <div className="ms-3">
                          <div className="d-flex align-items-center gap-2">
                            <h5
                              className="mb-1 fw-semibold text-capitalize"
                              style={{
                                fontSize: "16px",
                                color: "#111827",
                              }}
                            >
                              {cat?.name}
                            </h5>

                            {/* {subCategoryLength > 0 && (
                            <i className="ri-arrow-right-s-line fs-5"></i>
                          )} */}
                          </div>

                          {/* MAIN CATEGORY */}
                          {!cat?.isSubCategory ? (
                            <>
                              {cat?.description && (
                                <p
                                  className="mb-2"
                                  style={{
                                    fontSize: "14px",
                                    color: "#6B7280",
                                  }}
                                >
                                  {cat?.description}
                                </p>
                              )}

                              <div
                                className="d-flex flex-wrap gap-3"
                                style={{
                                  fontSize: "13px",
                                  color: "#6B7280",
                                }}
                              >
                                <span>{itemLength} items</span>
                                <span>{subCategoryLength} sub-categories</span>
                              </div>
                            </>
                          ) : (
                            /* SUB CATEGORY */
                            <div
                              style={{
                                fontSize: "13px",
                                color: "#6B7280",
                              }}
                            >
                              {subCategoryLength} types
                            </div>
                          )}
                        </div>
                      </div>

                      {/* ACTION BUTTONS */}
                      <div className="d-flex align-items-center gap-2">
                        {categoryPermission?.has("update") && (
                          <button
                            type="button"
                            className="btn btn-light p-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "6px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick(cat);
                            }}
                          >
                            <i
                              className="ri-pencil-line text-dark"
                              style={{ fontSize: "15px" }}
                            ></i>
                          </button>
                        )}

                        {categoryPermission?.has("delete") && (
                          <button
                            type="button"
                            className="btn p-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "6px",
                              backgroundColor: "#FEE2E2",
                            }}
                            onClick={(e) => handleDelete(e, cat)}
                          >
                            <i
                              className="ri-delete-bin-6-line"
                              style={{ fontSize: "15px", color: "#DC2626" }}
                            ></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    );
  };

  return (
    <>
      <Row>
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100 ps-3 pe-4">
          <div>
            <h5 className="rv-page-title p-1 mb-1 mb-md-0">
              {navigationStack.length === 0
                ? "Item Categories"
                : navigationStack.length === 1
                  ? "Sub Categories"
                  : "Category Details"}
            </h5>

            {navigationStack.length > 0 && (
              <div
                style={{
                  fontSize: "13px",
                  color: "#6B7280",
                  textTransform: "capitalize",
                }}
              ></div>
            )}
          </div>

          {categoryPermission?.has("create") && (
            <Button
              className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1"
              onClick={handleAddClick}
            >
              <i className="ri-add-fill label-icon fs-16 me-1 fw-bold"></i>

              <span className="ps-2 pe-2 fw-bold">
                {navigationStack.length === 0
                  ? "Add Category"
                  : "Add Sub Category"}
              </span>
            </Button>
          )}
        </div>
      </Row>

      {/* CATEGORY CARDS */}
      <div className="ps-2 pe-2 mt-3">
        {loading && <Loader />}

        {navigationStack.length > 0 && (
          <div className="d-flex align-items-center mb-3">
            <Button
              size="sm"
              color="light"
              onClick={handleBack}
              className="me-2 border"
            >
              <i className="ri-arrow-left-line"></i>
            </Button>

            <div className="d-flex align-items-center flex-wrap">
              <span
                style={{
                  fontWeight: 500,
                  color: "#6B7280",
                }}
              >
                Categories
              </span>

              {navigationStack.map((item, index) => (
                <React.Fragment key={item.categoryid}>
                  <i className="ri-arrow-right-s-line mx-1"></i>

                  <span
                    style={{
                      fontWeight:
                        index === navigationStack.length - 1 ? 600 : 500,
                      color:
                        index === navigationStack.length - 1
                          ? "#111827"
                          : "#6B7280",
                      textTransform: "capitalize",
                    }}
                  >
                    {item?.name}
                  </span>
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {/* CATEGORY LIST */}
        {/* {renderCategoryCards(currentCategories)} */}

        {currentCategories?.length > 0 ? (
          renderCategoryCards(currentCategories)
        ) : (
          <div className="text-center py-5 text-muted">
            {navigationStack.length === 0
              ? "No categories found"
              : "No sub categories found"}
          </div>
        )}
      </div>

      {/* ADD / EDIT MODAL */}
      <Modal
        isOpen={showModal}
        toggle={toggleModal}
        centered
        size={selectedCategory ? "md" : "lg"}
      >
        <ModalHeader
          toggle={toggleModal}
          style={{
            borderBottom: "1px solid #FD7545",
            padding: "16px 20px",
          }}
        >
          <span
            style={{
              color: "#FD7545",
              fontWeight: 600,
            }}
          >
            {selectedCategory
              ? selectedCategory?.isSubCategory
                ? "Edit Sub Category"
                : "Edit Category"
              : "Add New Category"}
          </span>
        </ModalHeader>

        <ModalBody
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
            padding: "20px 20px 0px 20px",
          }}
        >
          <CategoryForm
            closeModal={toggleModal}
            onSuccess={handleSuccess}
            selectedCategory={selectedCategory}
            navigationStack={navigationStack}
          />
        </ModalBody>
      </Modal>

      {/* DELETE MODAL */}
      <CommonModal
        open={deleteModal}
        toggle={toggleDeleteModal}
        buttonText={"Yes, Delete It"}
        messageForPopUp={messageForPopUp}
        modalHeader={`Delete ${
          deleteCategoryData?.isSubCategory ? "Sub Category" : "Category"
        }`}
        modalAction={() => {
          if (deleteCategoryData?.isSubCategory) {
            dispatch(
              deleteSubCategory(
                deleteCategoryData?.rootCategoryId,
                deleteCategoryData?.subCategoryId,
                setLoading,
              ),
            );
          } else {
            dispatch(
              deleteCategory(deleteCategoryData?.categoryid, setLoading),
            );
          }

          setNavigationStack([]);

          setCurrentCategories(
            category?.map((item) => ({
              ...item,
              isSubCategory: false,
            })) || [],
          );

          toggleDeleteModal();
        }}
      />
    </>
  );
}

export default CategoryCard;
